import React from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar = () => {
  return (
    <aside className="app-shell__sidebar" aria-label="Primary">
      <nav className="sidebar__nav">
        <NavLink
          to="/dashboard"
          end
          className={({ isActive }) =>
            `sidebar__link${isActive ? ' sidebar__link--active' : ''}`
          }
        >
          Dashboard
        </NavLink>
        <NavLink
          to="/game"
          className={({ isActive }) =>
            `sidebar__link${isActive ? ' sidebar__link--active' : ''}`
          }
        >
          Play BitWheel
        </NavLink>
      </nav>
    </aside>
  );
};

export default Sidebar;

